export enum WelcomeSystemStepEnum {
  GREETINGS = 'GREETINGS',
  IMPORT_SELECTION_TYPE = 'IMPORT_SELECTION_TYPE',
  IMPORT_SELECTION_BANK = 'IMPORT_SELECTION_BANK',
  IMPORT_FROM_BANK = 'IMPORT_FROM_BANK',
  IMPORT_FROM_1C = 'IMPORT_FROM_1C'
}
